import React from 'react';
import styles from './footer.module.css';

function Footer() {
    return(
        <div className="footer">
            <div className={styles.footer1}>Verktøypartner AS</div>
            <div className={styles.footer1}>Olaf Helsets vei 5, 0964 Oslo</div>
            <div className={styles.footer1}>Tel. 22 61 41 01 | E-post: ab@verktoypartner.no</div>
        </div>
    )
}

export default Footer;